import { Navigate, useSearchParams } from 'react-router';

import { TokenTypeCodeUnion } from '@/services/types';
import { ServiceErrorCode } from '@/services/utils/service-error';

import { VerifyErrorSection } from './verify-error-section';

export default function VerifyError() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const type = (searchParams.get('type') ?? '') as TokenTypeCodeUnion;
  const email = searchParams.get('email') ?? '';
  const errorCode = (searchParams.get('errorCode') ?? '') as ServiceErrorCode;

  if (!token || !type || !errorCode || !email) {
    return <Navigate to="/login" replace />;
  }

  const decodedEmail = decodeURIComponent(email);

  return (
    <VerifyErrorSection errorCode={errorCode} type={type} email={decodedEmail} />
  );
}
